import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { BackdropLoader, toast } from '@livable/saas-react-components';
import { Button, Grid, TextField, Typography, Paper, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { Link as RouterLink } from 'react-router-dom';
import { useStore } from 'src/stores';
import { USER_ROLES_TO_NAME } from 'src/constants/userSetting';
export const ManageAccessForm = observer(_ref => {
  var _propertyData$accessR, _portfolioData$access, _teamMembersList$filt;
  let handleModalClose = _ref.handleModalClose,
    onSave = _ref.onSave,
    propertyData = _ref.propertyData,
    portfolioData = _ref.portfolioData,
    hideFooter = _ref.hideFooter,
    noPadding = _ref.noPadding,
    triggerRefresh = _ref.triggerRefresh,
    disableMembersListScroll = _ref.disableMembersListScroll,
    setGrantedTeamMembersIdsExternal = _ref.setGrantedTeamMembersIdsExternal,
    initialGrantedTeamMembersIds = _ref.initialGrantedTeamMembersIds,
    isBatchOp = _ref.isBatchOp,
    disableFormMinHeight = _ref.disableFormMinHeight;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const arraysEqual = (a, b) => {
    if (!a || !b) return false;
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((value, index) => value === sortedB[index]);
  };
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchKey = _useState2[0],
    setSearchKey = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    teamMembersList = _useState6[0],
    setTeamMembersList = _useState6[1];
  const allTeamMembersIds = teamMembersList && teamMembersList.filter(i => USER_ROLES_TO_NAME[i.userRole] !== USER_ROLES_TO_NAME.PropertyManagerAccountHolder).map(i => i === null || i === void 0 ? void 0 : i.accountId);
  const _useState7 = useState((propertyData === null || propertyData === void 0 || (_propertyData$accessR = propertyData.accessResponses) === null || _propertyData$accessR === void 0 ? void 0 : _propertyData$accessR.map(i => i.accountId)) || (portfolioData === null || portfolioData === void 0 || (_portfolioData$access = portfolioData.accessResponses) === null || _portfolioData$access === void 0 ? void 0 : _portfolioData$access.map(i => i.accountId)) || initialGrantedTeamMembersIds || []),
    _useState8 = _slicedToArray(_useState7, 2),
    grantedTeamMembersIds = _useState8[0],
    setGrantedTeamMembersIds = _useState8[1];
  const fetchTeamMemberList = async () => {
    const teamMembersResp = await store.teamMembers.getCompanyTeamMembersAggregateAsync.run({});
    if (teamMembersResp !== null && teamMembersResp !== void 0 && teamMembersResp.isSuccessful) {
      var _teamMembersResp$resp;
      setTeamMembersList(teamMembersResp === null || teamMembersResp === void 0 || (_teamMembersResp$resp = teamMembersResp.response) === null || _teamMembersResp$resp === void 0 ? void 0 : _teamMembersResp$resp.teamMembers);
    }
    setIsLoading(false);
  };
  const handleGrantAccess = (event, accountId) => {
    event.stopPropagation();
    if (accountId === 'select_all') {
      if (arraysEqual(grantedTeamMembersIds, allTeamMembersIds)) {
        setGrantedTeamMembersIds([]);
        if (!!setGrantedTeamMembersIdsExternal) {
          setGrantedTeamMembersIdsExternal([]);
        }
      } else {
        setGrantedTeamMembersIds(allTeamMembersIds);
        if (!!setGrantedTeamMembersIdsExternal) {
          setGrantedTeamMembersIdsExternal(allTeamMembersIds);
        }
      }
      return;
    }
    const grantedTeamMembersIdsInt = [...grantedTeamMembersIds];
    if ((grantedTeamMembersIdsInt === null || grantedTeamMembersIdsInt === void 0 ? void 0 : grantedTeamMembersIdsInt.length) === 0 || (grantedTeamMembersIdsInt === null || grantedTeamMembersIdsInt === void 0 ? void 0 : grantedTeamMembersIdsInt.length) >= 0 && grantedTeamMembersIdsInt.findIndex(i => i === accountId) === -1) {
      setGrantedTeamMembersIds([...grantedTeamMembersIdsInt, accountId]);
      if (!!setGrantedTeamMembersIdsExternal) {
        setGrantedTeamMembersIdsExternal([...grantedTeamMembersIdsInt, accountId]);
      }
    } else {
      setGrantedTeamMembersIds([...grantedTeamMembersIdsInt.filter(id => id !== accountId)]);
      if (!!setGrantedTeamMembersIdsExternal) {
        setGrantedTeamMembersIdsExternal([...grantedTeamMembersIdsInt.filter(id => id !== accountId)]);
      }
    }
  };
  const handleSubmit = async event => {
    var _store$portfoliosMult, _assignResp;
    event.stopPropagation();
    // store.portfoliosMultiActionStore.selectedItems
    setIsLoading(true);
    let assignResp = null;
    if (propertyData !== null && propertyData !== null && propertyData !== void 0 && propertyData.propertyId) {
      assignResp = await store.account.assignResourceTeamMemberAsync.run({
        propertyId: propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyId,
        portfolioId: null,
        accountIds: grantedTeamMembersIds
      });
    }
    if (portfolioData !== null && portfolioData !== null && portfolioData !== void 0 && portfolioData.id) {
      assignResp = await store.account.assignResourceTeamMemberAsync.run({
        propertyId: null,
        portfolioId: portfolioData.id,
        accountIds: grantedTeamMembersIds
      });
    }
    if (isBatchOp && !!((_store$portfoliosMult = store.portfoliosMultiActionStore.selectedItems) !== null && _store$portfoliosMult !== void 0 && _store$portfoliosMult.length)) {
      for (const property of store.portfoliosMultiActionStore.selectedItems) {
        await store.account.assignResourceTeamMemberAsync.run({
          propertyId: property.propertyId,
          portfolioId: null,
          accountIds: grantedTeamMembersIds
        });
      }
    }
    if (assignResp && (_assignResp = assignResp) !== null && _assignResp !== void 0 && _assignResp.isSuccessful) {
      toast('success', {
        body: [t('general.successfully_saved')]
      });
    }
    setIsLoading(false);

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    onSave && onSave();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    triggerRefresh && triggerRefresh();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    handleModalClose && handleModalClose();
  };
  useEffect(() => {
    setIsLoading(true);
    fetchTeamMemberList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.formContent, " ").concat(disableFormMinHeight ? 'disableMinHeight' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.formContentHeader, " ").concat(!!noPadding ? classes.resetPadding : '')
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('team_page.grant_access')), !store.account.userProfile.isUserPropertyManagerRegular && /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    component: RouterLink,
    id: "team_settings",
    to: "/team_settings",
    target: "_blank",
    rel: "noopener noreferrer",
    'custom-attribute': '340-ManageAccessModal'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('team_page.manage_your_team')))), !store.account.userProfile.isUserPropertyManagerRegular && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.formContentInviteSearchSection, " ").concat(!!noPadding ? classes.resetPadding : '')
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "search-team-member",
    name: "search-team-member",
    label: t('team_page.search_pms_by_emails'),
    variant: "outlined",
    value: searchKey,
    onChange: event => {
      setSearchKey(event.target.value);
    },
    fullWidth: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.selectAll
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    label: !!arraysEqual(grantedTeamMembersIds, allTeamMembersIds) ? t('general.deselect_all') : t('general.select_all'),
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: !!arraysEqual(grantedTeamMembersIds, allTeamMembersIds),
      onClick: event => handleGrantAccess(event, 'select_all')
    })
  }))), teamMembersList && !!((_teamMembersList$filt = teamMembersList.filter(i => USER_ROLES_TO_NAME[i.userRole] !== USER_ROLES_TO_NAME.PropertyManagerAccountHolder)) !== null && _teamMembersList$filt !== void 0 && _teamMembersList$filt.length) ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(!!disableMembersListScroll ? classes.formContentMembersListDisableScroll : classes.formContentMembersList, " selectWrapper")
  }, teamMembersList.filter(i => i.isEnabled).filter(i => USER_ROLES_TO_NAME[i.userRole] !== USER_ROLES_TO_NAME.PropertyManagerAccountHolder).filter(tm => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(tm.email).search(searchPhrase) > 0 || " ".concat(tm.newEmail).search(searchPhrase) > 0 || " ".concat(tm.firstName, " ").concat(tm.lastName).search(searchPhrase) > 0 : true;
  }).map(item => /*#__PURE__*/React.createElement("div", {
    key: item.accountId,
    className: "".concat(classes.teamMember, " multiple} ").concat(grantedTeamMembersIds.findIndex(i => i === item.accountId) !== -1 ? 'selected' : '', " ").concat(!!(grantedTeamMembersIds !== null && grantedTeamMembersIds !== void 0 && grantedTeamMembersIds.length) && grantedTeamMembersIds.findIndex(i => i === item.accountId) !== -1 ? classes.activeItem : '')
  }, /*#__PURE__*/React.createElement("div", {
    key: item.accountId,
    className: classes.teamMemberInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.checkbox
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      onClick: event => handleGrantAccess(event, item.accountId),
      checked: grantedTeamMembersIds.findIndex(i => i === item.accountId) !== -1
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.avatar
  }, item.firstName.charAt(0)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "".concat(item.firstName, " ").concat(item.lastName)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.email
  }, item.newEmail || item.email)))))) : /*#__PURE__*/React.createElement("div", {
    className: classes.noTeamMembers
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('team_page.no_team_members'))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), !hideFooter && /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => handleModalClose(),
    'custom-attribute': '343-ManageAccessModal'
  }, t('buttons.cancel')))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.rightButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: handleSubmit,
    'custom-attribute': '344-ManageAccessModal'
  }, t('add_new_property_flow.save_and_close')))))));
});